import React from "react";
import Navbar from "./Navbar";
import PageTitle from './components/PageTitle';


const StudentDashboard = () => (
  <div>
    <PageTitle title="Student Dashboard" description="Student dashboard for medical students" />
    <Navbar pageTitle="Medical Student Dashboard" />
    <div className="container py-4">
      <h2>Welcome, Medical Student!</h2>
      <p>This is your dashboard.</p>
    </div>
  </div>
);

export default StudentDashboard; 